export const NUMBER_GREATER_THAN = '>'
export const NUMBER_LESS_THAN = '<'
export const NUMBER_IS = '=='
export const NUMBER_IS_NOT = '!='
export const NUMBER_IS_UNKNOWN = 'unknown'
export const NUMBER_ANY = 'any'

export const numberOperators = Object.freeze({
    equal: {
        key: NUMBER_IS,
        label: 'Is',
        json: {
            getLogic: (a, b) => ({
                [NUMBER_IS]: [{'var': a}, Number(b)]
            }),
            getData: () => null
        }
    },
    notEqual: {
        key: NUMBER_IS_NOT,
        label: 'Is not',
        json: {
            getLogic: (a, b) => ({
                [NUMBER_IS_NOT]: [{'var': a}, Number(b)]
            }),
            getData: () => null
        }
    },
    greaterThan: {
        key: NUMBER_GREATER_THAN,
        label: 'Greater than',
        json: {
            getLogic: (a, b) => ({
                [NUMBER_GREATER_THAN]: [{'var': a}, Number(b)]
            }),
            getData: () => null
        }
    },
    lessThan: {
        key: NUMBER_LESS_THAN,
        label: 'Less than',
        json: {
            getLogic: (a, b) => ({
                [NUMBER_LESS_THAN]: [{'var': a}, Number(b)]
            }),
            getData: () => null
        }
    },
    unknown: {
        key: NUMBER_IS_UNKNOWN,
        label: 'Is unknown',
        json: {
            getLogic: (a, b) => ({
                [NUMBER_IS_UNKNOWN]: [{'var': a}, b]
            }),
            getData: () => null
        }
    },
    any: {
        key: NUMBER_ANY,
        label: 'Has any value',
        json: {
            getLogic: (a, b) => ({
                [NUMBER_ANY]: [{'var': a}, b]
            }), // always true
            getData: () => null
        }
    }
})

export const numberOperatorsList = Object.freeze(Object.values(numberOperators))
